import {
  SubjectType,
  Subject,
  LegalEntity,
  BusinessNaturalPerson,
  DomainObject,
  SubjectRegistration,
  SubjectRegistrationType,
} from '../../models';
import { get } from 'lodash';

type DecoratedWithSubject = DomainObject & {
  [k: string]: Subject | SubjectRegistration;
};

export function icoValueMapperFactory(prefix?: string) {
  const valueMapper = function icoValueMapper({ rowValue }: { rowValue: any }) {
    const row = prefix
      ? get(rowValue as DecoratedWithSubject, prefix)
      : (rowValue as Subject | SubjectRegistration);

    let ico: string | undefined = '';
    if (
      row?.type === SubjectType.LEGAL_ENTITY ||
      row?.type === SubjectRegistrationType.LEGAL_ENTITY_REGISTRATION
    ) {
      ico = (row as LegalEntity).ico;
    } else if (
      row?.type === SubjectType.BUSINESS_NATURAL_PERSON ||
      row?.type === SubjectRegistrationType.BUSINESS_NATURAL_PERSON_REGISTRATION
    ) {
      ico = (row as BusinessNaturalPerson).ico?.value;
    } else {
      ico = '-';
    }

    return ico;
  };

  valueMapper.displayName = 'icoValueMapper';
  valueMapper.data = prefix;

  return valueMapper;
}
